import { asPractitionerId, type PractitionerId } from "@repo/domain";
import { z } from "zod";

export const practitionerIdSchema: z.ZodType<PractitionerId, z.ZodTypeDef, string> = z
  .string()
  .min(1)
  .transform(asPractitionerId);

export const practitionerRefSchema = z.object({ resourceType: z.literal("Practitioner"), id: practitionerIdSchema });

/** Input for setting a clinician's Google Workspace identity (MIN-281). */
export const setPractitionerGoogleWorkspaceEmailInputSchema = z.object({
  id: practitionerIdSchema,
  googleWorkspaceEmail: z.string().min(1),
});

export type SetPractitionerGoogleWorkspaceEmailInput = z.infer<typeof setPractitionerGoogleWorkspaceEmailInputSchema>;
